/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const loginCognitoUser = /* GraphQL */ `mutation LoginCognitoUser($LinkedSessionID: String) {
  loginCognitoUser(LinkedSessionID: $LinkedSessionID) {
    sessionid
    cognitousername
    logintimestamp
    logouttimestamp
    linkedsessionid
    deviceinfo
    ipaddress
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LoginCognitoUserMutationVariables,
  APITypes.LoginCognitoUserMutation
>;
export const logoutCognitoUser = /* GraphQL */ `mutation LogoutCognitoUser {
  logoutCognitoUser {
    sessionid
    cognitousername
    logintimestamp
    logouttimestamp
    linkedsessionid
    deviceinfo
    ipaddress
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LogoutCognitoUserMutationVariables,
  APITypes.LogoutCognitoUserMutation
>;
export const logoutCognitoUserv2 = /* GraphQL */ `mutation LogoutCognitoUserv2 {
  logoutCognitoUserv2 {
    sessionid
    cognitousername
    logintimestamp
    logouttimestamp
    linkedsessionid
    deviceinfo
    ipaddress
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LogoutCognitoUserv2MutationVariables,
  APITypes.LogoutCognitoUserv2Mutation
>;
export const createPartyTransaction = /* GraphQL */ `mutation CreatePartyTransaction(
  $createPartyTransactionInput: CreatePartyTransactionInput!
) {
  createPartyTransaction(
    createPartyTransactionInput: $createPartyTransactionInput
  ) {
    partyid
    accountid
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyTransactionMutationVariables,
  APITypes.CreatePartyTransactionMutation
>;
export const createItemTransaction = /* GraphQL */ `mutation CreateItemTransaction(
  $createItemTransactionInput: CreateItemTransactionInput!
) {
  createItemTransaction(
    createItemTransactionInput: $createItemTransactionInput
  ) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    lastupdatedby
    itemamountenteredtimestamp
    itemamountexpiredtimestamp
    amount
    effectivedate
    expireddate
    sellinghsnid
    purchasehsnid
    gstcompensationtype
    gstcompensationvalue
    gstrate
    discounttype
    discountvalue
    imagename
    imageurl
    serialnumber
    isdefault
    invoicetype
    defaultsellingprice
    defaultpurchaseprice
    codetext
    itemcategory
    sellinggstcompensationtype
    purchasegstcompensationtype
    sellinggstcompensationvalue
    purchasegstcompensationvalue
    sellinggstrate
    purchasegstrate
    sellingdiscounttype
    purchasediscounttype
    sellingdiscountvalue
    purchasediscountvalue
    purchaseaccountname
    salesaccountname
    defaultnetsellingprice
    defaultnetpurchaseprice
    description
    hsnsacid
    hsncodetype
    hsnsaccode
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemTransactionMutationVariables,
  APITypes.CreateItemTransactionMutation
>;
export const createSalesInvoice = /* GraphQL */ `mutation CreateSalesInvoice(
  $createSalesInvoiceInput: CreateSalesInvoiceInput!
) {
  createSalesInvoice(createSalesInvoiceInput: $createSalesInvoiceInput) {
    invoiceid
    companyid
    statuscode
    statusmessage
    invoicenumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSalesInvoiceMutationVariables,
  APITypes.CreateSalesInvoiceMutation
>;
export const createSalesPosInvoiceTemp = /* GraphQL */ `mutation CreateSalesPosInvoiceTemp(
  $createSalesInvoiceInput: CreateSalesPosInvoiceInputTemp!
) {
  createSalesPosInvoiceTemp(createSalesInvoiceInput: $createSalesInvoiceInput) {
    invoiceid
    companyid
    statuscode
    statusmessage
    invoicenumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSalesPosInvoiceTempMutationVariables,
  APITypes.CreateSalesPosInvoiceTempMutation
>;
export const createCompanyFYv2 = /* GraphQL */ `mutation CreateCompanyFYv2($createCompanyFYInput: CreateCompanyFYInputv2!) {
  createCompanyFYv2(createCompanyFYInput: $createCompanyFYInput) {
    companyid
    enteredtimestamp
    expiredtimestamp
    companyname
    statuscode
    statusmessage
    relatedcompanydetailsnew {
      companyid
      enteredtimestamp
      expiredtimestamp
      websiteurl
      currencycd
      accountinventoryflag
      pannumber
      tdstcsnumber
      cinregistrationnumber
      registrationtype
      comppercentage
      gstrperiod
      lut
      lutbondvalidfrom
      ewaybillflag
      gstapplicablefrom
      thresholdlimitcd
      thresholdlimitamount
      companylegalname
      companyshort
      lutbondtodate
      invoicedetailapplicablefromdate
      tdsapplicable
      gstcategory
      financialyearstartandendmonth
      companylogourl
      msmetype
      udhyamregno
      udhyamdocs
      ewaybillstartdate
      minamountewayinter
      minamountewayintra
      einvoiceflag
      einvoicestartingdate
      gstcompensationcessflag
      tradelicensenumber
      tradelicensestartdate
      tradelicenseenddate
      lastupdatedby
      cinregistrationdate
      einvoiceconnect
      statuscode
      statusmessage
      activeflag
      relatedfinancialyeardata {
        financialyearid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        startdate
        enddate
        startyear
        endyear
        comments
        userid
        aliasname
        statuscode
        statusmessage
        freezestatus
        transferdate
        freezedate
        stepscompleted
        __typename
      }
      financialyearid
      lastupdatedtimestamp
      companydeletiontime
      ewaybillconnect
      stepscompleted
      disablegstcompensation
      businesstypeid
      industrytypeid
      __typename
    }
    relatedcompanyentity {
      id
      companyid
      enteredtimestamp
      expiredtimestamp
      legalname
      gstin
      financialyearcode
      companyentitytype
      startdate
      statuscode
      statusmessage
      lastupdatedby
      financialyearid
      __typename
    }
    relatedemailcontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      emailaddress
      verifieddatetime
      promotionssignup
      statuscode
      statusmessage
      lastupdatedby
      __typename
    }
    relatedphonecontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      countrycode
      phonenumber
      verifieddatetime
      promotionssignup
      smsallowed
      callallowed
      whatsappallowed
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedaddressentity {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    addressentityid
    objecttype
    line1
    line2
    line3
    city
    statecode
    statename
    pincode
    countrycode
    district
    financialyearid
    einvoiceusername
    companydeletiontime
    ewaybillusername
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyFYv2MutationVariables,
  APITypes.CreateCompanyFYv2Mutation
>;
export const createPurchaseInvoice = /* GraphQL */ `mutation CreatePurchaseInvoice(
  $createPurchaseInvoiceInput: CreatePurchaseInvoiceInput!
) {
  createPurchaseInvoice(
    createPurchaseInvoiceInput: $createPurchaseInvoiceInput
  ) {
    purchaseid
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseInvoiceMutationVariables,
  APITypes.CreatePurchaseInvoiceMutation
>;
export const createTransactionWithSpecificTime = /* GraphQL */ `mutation CreateTransactionWithSpecificTime(
  $transactionmaster: AWSJSON!
  $transactiondetails: AWSJSON!
  $transactionrelation: AWSJSON!
  $transactionattachment: AWSJSON!
  $transactiontcsdetails: AWSJSON!
  $transactiontdsdetails: AWSJSON!
  $mode: Int!
) {
  createTransactionWithSpecificTime(
    transactionmaster: $transactionmaster
    transactiondetails: $transactiondetails
    transactionrelation: $transactionrelation
    transactionattachment: $transactionattachment
    transactiontcsdetails: $transactiontcsdetails
    transactiontdsdetails: $transactiontdsdetails
    mode: $mode
  ) {
    transactionid
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionWithSpecificTimeMutationVariables,
  APITypes.CreateTransactionWithSpecificTimeMutation
>;
export const createCrDrNoteTransactionsArray = /* GraphQL */ `mutation CreateCrDrNoteTransactionsArray(
  $createCrDrNoteTransactionsArrayInput: CreateCrDrNoteTransactionsArrayInput!
) {
  createCrDrNoteTransactionsArray(
    createCrDrNoteTransactionsArrayInput: $createCrDrNoteTransactionsArrayInput
  ) {
    crdrnoteid
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteTransactionsArrayMutationVariables,
  APITypes.CreateCrDrNoteTransactionsArrayMutation
>;
export const createAccountOpeningBalancesTransaction = /* GraphQL */ `mutation CreateAccountOpeningBalancesTransaction(
  $createAccountOpeningBalancesArrayInput: CreateAccountOpeningBalancesArrayInput!
) {
  createAccountOpeningBalancesTransaction(
    createAccountOpeningBalancesArrayInput: $createAccountOpeningBalancesArrayInput
  ) {
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountOpeningBalancesTransactionMutationVariables,
  APITypes.CreateAccountOpeningBalancesTransactionMutation
>;
export const createItemCategorymaster = /* GraphQL */ `mutation CreateItemCategorymaster(
  $createItemCategorymasterInput: CreateItemCategorymasterInput!
) {
  createItemCategorymaster(
    createItemCategorymasterInput: $createItemCategorymasterInput
  ) {
    itemcategoryid
    companyid
    enteredtimestamp
    expiredtimestamp
    category
    itemcategorygroupid
    maincategory
    statuscode
    statusmessage
    lastupdatedby
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemCategorymasterMutationVariables,
  APITypes.CreateItemCategorymasterMutation
>;
export const createCompanyCodeTranslation = /* GraphQL */ `mutation CreateCompanyCodeTranslation(
  $createCompanyCodeTranslationInput: CreateCompanyCodeTranslationInput!
) {
  createCompanyCodeTranslation(
    createCompanyCodeTranslationInput: $createCompanyCodeTranslationInput
  ) {
    id
    companyid
    codetype
    codevalue
    language
    enteredtimestamp
    expiredtimestamp
    codetext
    codeorder
    statuscode
    statusmessage
    lastupdatedby
    uqc
    is_active
    section
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyCodeTranslationMutationVariables,
  APITypes.CreateCompanyCodeTranslationMutation
>;
export const createPriceType = /* GraphQL */ `mutation CreatePriceType($pricetype: AWSJSON) {
  createPriceType(pricetype: $pricetype) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    pricetype
    userid
    is_default
    is_active
    statuscode
    statusmessage
    tabletype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePriceTypeMutationVariables,
  APITypes.CreatePriceTypeMutation
>;
export const createAccountGroupMaster = /* GraphQL */ `mutation CreateAccountGroupMaster(
  $createAccountGroupMasterInput: CreateAccountGroupMasterInput!
) {
  createAccountGroupMaster(
    createAccountGroupMasterInput: $createAccountGroupMasterInput
  ) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountGroupMasterMutationVariables,
  APITypes.CreateAccountGroupMasterMutation
>;
export const createInvoiceSettings = /* GraphQL */ `mutation CreateInvoiceSettings(
  $invoiceSettingsInput: [InvoiceSettingsInput!]!
) {
  createInvoiceSettings(invoiceSettingsInput: $invoiceSettingsInput) {
    invoicesettingsid
    companyid
    enteredtimestamp
    expiredtimestamp
    typecd
    invoiceheading
    signaturetext
    declarationatfooter
    termsandcondition
    declarationatfooterflag
    termsandconditionsflag
    companyname
    companycin
    invoicenumber
    companyaddress
    companylogo
    invoicedate
    companycontactnumber
    companyemail
    paymentmode
    companygstin
    companywebsite
    creditperiod
    companypan
    companybankdetails
    paymentduedate
    customerlegalname
    customergstin
    lutbonddetails
    customerdisplayname
    placeofsupply
    dispatchdetails
    customerbillingaddress
    customercontactperson
    customercontactnumber
    customername
    ewaybilldetails
    customershippingaddress
    customerordernoanddate
    einvoicedetails
    itemwisediscount
    hsnsacode
    showroundoff
    hsnsasummarytable
    invoicedescription
    regularinvoicesignaturefilename
    last_updated_by
    statuscode
    statusmessage
    posinvoicesignaturefilename
    defaultsetting
    bankdetails
    upi_id
    acknowledgement
    acknowledgementflag
    bosinvoiceheading
    bank_name
    branch
    ac_name
    ac_no
    ifsc
    swift_code
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceSettingsMutationVariables,
  APITypes.CreateInvoiceSettingsMutation
>;
export const createAccountMaster = /* GraphQL */ `mutation CreateAccountMaster(
  $createAccountMasterInput: CreateAccountMasterInput!
) {
  createAccountMaster(createAccountMasterInput: $createAccountMasterInput) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountMasterMutationVariables,
  APITypes.CreateAccountMasterMutation
>;
export const createcompanydetails = /* GraphQL */ `mutation Createcompanydetails(
  $createCompanyDetailsInput: [CreateCompanyDetailsInput!]!
) {
  createcompanydetails(createCompanyDetailsInput: $createCompanyDetailsInput) {
    companyid
    enteredtimestamp
    expiredtimestamp
    websiteurl
    currencycd
    accountinventoryflag
    pannumber
    tdstcsnumber
    cinregistrationnumber
    registrationtype
    comppercentage
    gstrperiod
    lut
    lutbondvalidfrom
    ewaybillflag
    gstapplicablefrom
    thresholdlimitcd
    thresholdlimitamount
    companylegalname
    companyshort
    lutbondtodate
    invoicedetailapplicablefromdate
    tdsapplicable
    gstcategory
    financialyearstartandendmonth
    companylogourl
    msmetype
    udhyamregno
    udhyamdocs
    ewaybillstartdate
    minamountewayinter
    minamountewayintra
    einvoiceflag
    einvoicestartingdate
    gstcompensationcessflag
    tradelicensenumber
    tradelicensestartdate
    tradelicenseenddate
    lastupdatedby
    cinregistrationdate
    einvoiceconnect
    statuscode
    statusmessage
    activeflag
    relatedfinancialyeardata {
      financialyearid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      startdate
      enddate
      startyear
      endyear
      comments
      userid
      aliasname
      statuscode
      statusmessage
      freezestatus
      transferdate
      freezedate
      stepscompleted
      __typename
    }
    financialyearid
    lastupdatedtimestamp
    companydeletiontime
    ewaybillconnect
    stepscompleted
    disablegstcompensation
    businesstypeid
    industrytypeid
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatecompanydetailsMutationVariables,
  APITypes.CreatecompanydetailsMutation
>;
export const createcompanyentity = /* GraphQL */ `mutation Createcompanyentity(
  $createcompanyentityInput: [CreatecompanyentityInput!]!
) {
  createcompanyentity(createcompanyentityInput: $createcompanyentityInput) {
    id
    companyid
    enteredtimestamp
    expiredtimestamp
    legalname
    gstin
    financialyearcode
    companyentitytype
    startdate
    statuscode
    statusmessage
    lastupdatedby
    financialyearid
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatecompanyentityMutationVariables,
  APITypes.CreatecompanyentityMutation
>;
export const createAccountGSTDetails = /* GraphQL */ `mutation CreateAccountGSTDetails(
  $createAccountGSTDetailsInput: CreateAccountGSTDetailsInput!
) {
  createAccountGSTDetails(
    createAccountGSTDetailsInput: $createAccountGSTDetailsInput
  ) {
    accountid
    companyid
    enteredtimestamp
    expiredtimestamp
    effectivedate
    expireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    lastupdatedby
    statuscode
    statusmessage
    hsnsaccode
    codetype
    description
    taxability
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountGSTDetailsMutationVariables,
  APITypes.CreateAccountGSTDetailsMutation
>;
export const createHSNSACMaster = /* GraphQL */ `mutation CreateHSNSACMaster(
  $createHSNSACMasterInput: CreateHSNSACMasterInput!
) {
  createHSNSACMaster(createHSNSACMasterInput: $createHSNSACMasterInput) {
    hsnsacid
    codetype
    hsnsaccode
    description
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    statuscode
    statusmessage
    companyid
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHSNSACMasterMutationVariables,
  APITypes.CreateHSNSACMasterMutation
>;
export const createPartyCreditDetails = /* GraphQL */ `mutation CreatePartyCreditDetails(
  $createPartyCreditDetailsInput: CreatePartyCreditDetailsInput!
) {
  createPartyCreditDetails(
    createPartyCreditDetailsInput: $createPartyCreditDetailsInput
  ) {
    partyid
    enteredtimestamp
    expiredtimestamp
    creditperiodduration
    billingcurrency
    creditlimitcd
    creditlimitamount
    billwiseflag
    notes
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyCreditDetailsMutationVariables,
  APITypes.CreatePartyCreditDetailsMutation
>;
export const createPartyGSTDetails = /* GraphQL */ `mutation CreatePartyGSTDetails(
  $createPartyGSTDetailsInput: CreatePartyGSTDetailsInput!
) {
  createPartyGSTDetails(
    createPartyGSTDetailsInput: $createPartyGSTDetailsInput
  ) {
    partyid
    enteredtimestamp
    expiredtimestamp
    pannumber
    gstin
    partyaddressid
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyGSTDetailsMutationVariables,
  APITypes.CreatePartyGSTDetailsMutation
>;
export const createbusinessType = /* GraphQL */ `mutation CreatebusinessType($businessTypeInputs: [BusinessTypeInputs!]!) {
  createbusinessType(businessTypeInputs: $businessTypeInputs) {
    businesstypeid
    companyid
    enteredtimestamp
    expiredtimestamp
    businesstype
    lastupdatedby
    restrictedflag
    isactive
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatebusinessTypeMutationVariables,
  APITypes.CreatebusinessTypeMutation
>;
export const createindustryType = /* GraphQL */ `mutation CreateindustryType($industryTypeInputs: [IndustryTypeInputs!]!) {
  createindustryType(industryTypeInputs: $industryTypeInputs) {
    industrytypeid
    companyid
    enteredtimestamp
    expiredtimestamp
    industrytype
    lastupdatedby
    restrictedflag
    isactive
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateindustryTypeMutationVariables,
  APITypes.CreateindustryTypeMutation
>;
export const createBankDetails = /* GraphQL */ `mutation CreateBankDetails(
  $createBankDetailsInput: [CreateBankDetailsInput!]!
) {
  createBankDetails(createBankDetailsInput: $createBankDetailsInput) {
    bankdetailsid
    companyid
    companybranchid
    objecttype
    enteredtimestamp
    expiredtimestamp
    objectid
    userid
    bankname
    bankaccountnumber
    ifsccode
    branch
    notes
    ledgeraccount
    bankaccounttype
    cash
    swiftcode
    statuscode
    statusmessage
    relatedaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    upi
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBankDetailsMutationVariables,
  APITypes.CreateBankDetailsMutation
>;
export const createFinancialYear = /* GraphQL */ `mutation CreateFinancialYear(
  $createFinancialYearInput: CreateFinancialYearInput!
) {
  createFinancialYear(createFinancialYearInput: $createFinancialYearInput) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFinancialYearMutationVariables,
  APITypes.CreateFinancialYearMutation
>;
export const createUserPreference = /* GraphQL */ `mutation CreateUserPreference(
  $createUserPreferenceInput: CreateUserPreferenceInput!
) {
  createUserPreference(createUserPreferenceInput: $createUserPreferenceInput) {
    userid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserPreferenceMutationVariables,
  APITypes.CreateUserPreferenceMutation
>;
export const createCompanyPreference = /* GraphQL */ `mutation CreateCompanyPreference(
  $createCompanyPreferenceInput: CreateCompanyPreferenceInput!
) {
  createCompanyPreference(
    createCompanyPreferenceInput: $createCompanyPreferenceInput
  ) {
    companyid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyPreferenceMutationVariables,
  APITypes.CreateCompanyPreferenceMutation
>;
export const switchCompany = /* GraphQL */ `mutation SwitchCompany($companyid: Int!, $financialyearid: Int!) {
  switchCompany(companyid: $companyid, financialyearid: $financialyearid) {
    companyid
    financialyearid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SwitchCompanyMutationVariables,
  APITypes.SwitchCompanyMutation
>;
export const createPaymentSettings = /* GraphQL */ `mutation CreatePaymentSettings(
  $paymentSettingsInput: [PaymentSettingsInput!]!
) {
  createPaymentSettings(paymentSettingsInput: $paymentSettingsInput) {
    enable_itemwiseentry
    enable_creditperiod
    enable_creditlimit
    enable_autopayreminder
    enable_autoreminderdays
    companyid
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentSettingsMutationVariables,
  APITypes.CreatePaymentSettingsMutation
>;
export const createTransactionMaster = /* GraphQL */ `mutation CreateTransactionMaster(
  $createTransactionMasterInput: CreateTransactionMasterInput!
) {
  createTransactionMaster(
    createTransactionMasterInput: $createTransactionMasterInput
  ) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionMasterMutationVariables,
  APITypes.CreateTransactionMasterMutation
>;
export const createTransactionDetailsArray = /* GraphQL */ `mutation CreateTransactionDetailsArray(
  $createTransactionDetailsArrayInput: AWSJSON!
) {
  createTransactionDetailsArray(
    createTransactionDetailsArrayInput: $createTransactionDetailsArrayInput
  ) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    accountid
    creditamount
    debitamount
    comments
    entryordernumber
    transactionbalance
    openingbalance
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedaccountstransaction {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      vouchernumber
      transactionmastertypecd
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      financialyearid
      __typename
    }
    lastupdatedby
    financialyearid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionDetailsArrayMutationVariables,
  APITypes.CreateTransactionDetailsArrayMutation
>;
export const createTransactionRelation = /* GraphQL */ `mutation CreateTransactionRelation(
  $createTransactionRelationInput: CreateTransactionRelationInput!
) {
  createTransactionRelation(
    createTransactionRelationInput: $createTransactionRelationInput
  ) {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    linkedamount
    objectattribute
    isdirect
    lastupdatedby
    accountid
    paymentvouchernumber
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionRelationMutationVariables,
  APITypes.CreateTransactionRelationMutation
>;
export const createSetOff = /* GraphQL */ `mutation CreateSetOff(
  $sourceinvoiceid: Int!
  $sourcetransactiontype: String!
  $targetinvoiceid: Int!
  $targettransactiontype: String!
  $setoffamount: Float!
) {
  createSetOff(
    sourceinvoiceid: $sourceinvoiceid
    sourcetransactiontype: $sourcetransactiontype
    targetinvoiceid: $targetinvoiceid
    targettransactiontype: $targettransactiontype
    setoffamount: $setoffamount
  ) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSetOffMutationVariables,
  APITypes.CreateSetOffMutation
>;
export const createSetOffBatch = /* GraphQL */ `mutation CreateSetOffBatch(
  $targetaccountid: Int!
  $targetinvoiceid: Int!
  $targettransactiontype: String!
  $setoffitems: [SetOffItemInput!]!
) {
  createSetOffBatch(
    targetaccountid: $targetaccountid
    targetinvoiceid: $targetinvoiceid
    targettransactiontype: $targettransactiontype
    setoffitems: $setoffitems
  ) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSetOffBatchMutationVariables,
  APITypes.CreateSetOffBatchMutation
>;
export const createInvoicePOSDetails = /* GraphQL */ `mutation CreateInvoicePOSDetails(
  $createInvoicePOSDetailsInput: CreateInvoicePOSDetailsInput!
) {
  createInvoicePOSDetails(
    createInvoicePOSDetailsInput: $createInvoicePOSDetailsInput
  ) {
    posid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partyposid
    lastupdatedby
    relatedposparty {
      pospartyid
      companyid
      partyname
      partycontactnumberid
      lastupdatedby
      enteredtimestamp
      expiredtimestamp
      relatedphonecontacts {
        id
        objecttype
        objectid
        enteredtimestamp
        expiredtimestamp
        countrycode
        phonenumber
        verifieddatetime
        promotionssignup
        smsallowed
        callallowed
        whatsappallowed
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      __typename
    }
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoicePOSDetailsMutationVariables,
  APITypes.CreateInvoicePOSDetailsMutation
>;
export const createPOSParty = /* GraphQL */ `mutation CreatePOSParty($createPOSPartyInput: CreatePOSPartyInput) {
  createPOSParty(createPOSPartyInput: $createPOSPartyInput) {
    pospartyid
    companyid
    partyname
    partycontactnumberid
    lastupdatedby
    enteredtimestamp
    expiredtimestamp
    relatedphonecontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      countrycode
      phonenumber
      verifieddatetime
      promotionssignup
      smsallowed
      callallowed
      whatsappallowed
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePOSPartyMutationVariables,
  APITypes.CreatePOSPartyMutation
>;
export const createPhoneContacts = /* GraphQL */ `mutation CreatePhoneContacts(
  $createPhoneContactsInput: [CreatePhoneContactsInput]
) {
  createPhoneContacts(createPhoneContactsInput: $createPhoneContactsInput) {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    countrycode
    phonenumber
    verifieddatetime
    promotionssignup
    smsallowed
    callallowed
    whatsappallowed
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePhoneContactsMutationVariables,
  APITypes.CreatePhoneContactsMutation
>;
export const createNumberTracker = /* GraphQL */ `mutation CreateNumberTracker(
  $createNumberTrackerInput: [CreateNumberTrackerInput]
) {
  createNumberTracker(createNumberTrackerInput: $createNumberTrackerInput) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNumberTrackerMutationVariables,
  APITypes.CreateNumberTrackerMutation
>;
export const createPartyAddressEntity = /* GraphQL */ `mutation CreatePartyAddressEntity(
  $createPartyAddressEntityInput: [CreatePartyAddressEntityInput]!
) {
  createPartyAddressEntity(
    createPartyAddressEntityInput: $createPartyAddressEntityInput
  ) {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    line1
    line2
    line3
    city
    statecode
    statename
    statuscode
    statusmessage
    pincode
    countrycode
    codevalue
    district
    lastupdatedby
    godownname
    gstin
    phone
    email
    personincharge
    consigneename
    consigneegstin
    foreignstate
    foreigndistrict
    defaultflag
    addresstitle
    addressindex
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyAddressEntityMutationVariables,
  APITypes.CreatePartyAddressEntityMutation
>;
export const createCompanyDocuments = /* GraphQL */ `mutation CreateCompanyDocuments(
  $createCompanyDocumentsInput: [CreateCompanyDocumentsInput!]!
) {
  createCompanyDocuments(
    createCompanyDocumentsInput: $createCompanyDocumentsInput
  ) {
    id
    companyid
    partyid
    documenttype
    enteredtimestamp
    expiredtimestamp
    imagename
    imageurl
    lastupdatedby
    isactive
    type
    documentname
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyDocumentsMutationVariables,
  APITypes.CreateCompanyDocumentsMutation
>;
export const createEmailContacts = /* GraphQL */ `mutation CreateEmailContacts(
  $createEmailContactsInput: CreateEmailContactsInput!
) {
  createEmailContacts(createEmailContactsInput: $createEmailContactsInput) {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    emailaddress
    verifieddatetime
    promotionssignup
    statuscode
    statusmessage
    lastupdatedby
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmailContactsMutationVariables,
  APITypes.CreateEmailContactsMutation
>;
export const createMultipleTestEntries = /* GraphQL */ `mutation CreateMultipleTestEntries($inputArray: [TestInput!]!) {
  createMultipleTestEntries(inputArray: $inputArray) {
    id
    name
    value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMultipleTestEntriesMutationVariables,
  APITypes.CreateMultipleTestEntriesMutation
>;
export const createEInvoiceMaster = /* GraphQL */ `mutation CreateEInvoiceMaster($eInvoiceMasterInputs: [eInvoiceMasterInput!]!) {
  createEInvoiceMaster(eInvoiceMasterInputs: $eInvoiceMasterInputs) {
    id
    invoiceid
    invoicetype
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    ackno
    ackdt
    irn
    signedqrcode
    lastupdatedby
    is_cancelled
    cancel_reason
    cancel_remarks
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEInvoiceMasterMutationVariables,
  APITypes.CreateEInvoiceMasterMutation
>;
export const createEInvoiceUsers = /* GraphQL */ `mutation CreateEInvoiceUsers($eInvoiceUsersInputs: [EInvoiceUsersInput!]!) {
  createEInvoiceUsers(eInvoiceUsersInputs: $eInvoiceUsersInputs) {
    id
    companyid
    username
    password
    enteredtimestamp
    expiredtimestamp
    is_active
    lastupdatedby
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEInvoiceUsersMutationVariables,
  APITypes.CreateEInvoiceUsersMutation
>;
export const createItemMaster = /* GraphQL */ `mutation CreateItemMaster($createItemMasterInput: CreateItemMasterInput!) {
  createItemMaster(createItemMasterInput: $createItemMasterInput) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      id
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      pricetypeid
      tabletype
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    financialyearid
    description
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemMasterMutationVariables,
  APITypes.CreateItemMasterMutation
>;
export const createItemAmountDetails = /* GraphQL */ `mutation CreateItemAmountDetails(
  $createItemAmountDetailsInput: [CreateItemAmountDetailsInput!]!
) {
  createItemAmountDetails(
    createItemAmountDetailsInput: $createItemAmountDetailsInput
  ) {
    id
    itemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    amount
    effectivedate
    expireddate
    hsnid
    gstcompensationtype
    gstcompensationvalue
    gstrate
    statuscode
    statusmessage
    lastupdatedby
    discounttype
    discountvalue
    invoicetype
    pricetype
    isactive
    isdefault
    pricetypeid
    tabletype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemAmountDetailsMutationVariables,
  APITypes.CreateItemAmountDetailsMutation
>;
export const createItemImages = /* GraphQL */ `mutation CreateItemImages($createItemImagesInput: [CreateItemImagesInput!]!) {
  createItemImages(createItemImagesInput: $createItemImagesInput) {
    attachmentid
    itemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    imagename
    imageurl
    documentname
    type
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemImagesMutationVariables,
  APITypes.CreateItemImagesMutation
>;
export const createPartyMaster = /* GraphQL */ `mutation CreatePartyMaster($createPartyMasterInput: CreatePartyMasterInput!) {
  createPartyMaster(createPartyMasterInput: $createPartyMasterInput) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    accountname
    deliverystatecode
    deliverystatename
    contactcountry
    whatsappcountry
    entityname
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyMasterMutationVariables,
  APITypes.CreatePartyMasterMutation
>;
export const createPartyContact = /* GraphQL */ `mutation CreatePartyContact(
  $createPartyContactInput: [CreatePartyContactInput!]!
) {
  createPartyContact(createPartyContactInput: $createPartyContactInput) {
    partyid
    enteredtimestamp
    expiredtimestamp
    contacttypename
    contactdesignationname
    contactorder
    email
    phonenumber
    whatsappnumber
    lastupdatedby
    statuscode
    statusmessage
    contactcountry
    whatsappcountry
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyContactMutationVariables,
  APITypes.CreatePartyContactMutation
>;
export const createPartyImages = /* GraphQL */ `mutation CreatePartyImages(
  $createPartyImagesInput: [CreatePartyImagesInput!]!
) {
  createPartyImages(createPartyImagesInput: $createPartyImagesInput) {
    attachmentid
    partyid
    companyid
    enteredtimestamp
    expiredtimestamp
    type
    documentname
    imagename
    imageurl
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePartyImagesMutationVariables,
  APITypes.CreatePartyImagesMutation
>;
export const createInvoiceMaster = /* GraphQL */ `mutation CreateInvoiceMaster(
  $createInvoiceMasterInput: CreateInvoiceMasterInput!
) {
  createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceMasterMutationVariables,
  APITypes.CreateInvoiceMasterMutation
>;
export const createInvoiceAttachment = /* GraphQL */ `mutation CreateInvoiceAttachment(
  $createInvoiceAttachmentInput: [CreateInvoiceAttachmentInput]
) {
  createInvoiceAttachment(
    createInvoiceAttachmentInput: $createInvoiceAttachmentInput
  ) {
    invoiceid
    attachmentid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    attachmentname
    attachmenturl
    lastupdatedby
    statuscode
    statusmessage
    documentname
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceAttachmentMutationVariables,
  APITypes.CreateInvoiceAttachmentMutation
>;
export const createInvoiceDispatch = /* GraphQL */ `mutation CreateInvoiceDispatch(
  $createInvoiceDispatchInput: [CreateInvoiceDispatchInput]
) {
  createInvoiceDispatch(
    createInvoiceDispatchInput: $createInvoiceDispatchInput
  ) {
    invoiceid
    dispatchid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transportationcd
    vehiclenumber
    dispatchdate
    ewaybillnumber
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceDispatchMutationVariables,
  APITypes.CreateInvoiceDispatchMutation
>;
export const createInvoiceLineGST = /* GraphQL */ `mutation CreateInvoiceLineGST(
  $createInvoiceLineGSTInput: [CreateInvoiceLineGSTInput]
) {
  createInvoiceLineGST(createInvoiceLineGSTInput: $createInvoiceLineGSTInput) {
    invoiceid
    invoiceitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    gstrate
    gsttypecd
    gstamount
    cessamount
    cessrate
    cesstype
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceLineGSTMutationVariables,
  APITypes.CreateInvoiceLineGSTMutation
>;
export const createInvoiceLineItems = /* GraphQL */ `mutation CreateInvoiceLineItems(
  $createInvoiceLineItemsInput: [CreateInvoiceLineItemsInput]
) {
  createInvoiceLineItems(
    createInvoiceLineItemsInput: $createInvoiceLineItemsInput
  ) {
    invoiceid
    invoiceitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    lineitemnumber
    invoicelineitemtype
    itemid
    quantity
    unittypecd
    itemrate
    itemamount
    itemdiscount
    discounttype
    discountrate
    netamount
    hsnsaccode
    taxability
    lastupdatedby
    statuscode
    statusmessage
    pricetype
    lotid
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    gstrate
    gsttypecd
    gstamount
    cessamount
    unit
    uqc
    salesaccountname
    salesaccountid
    itemname
    itemcode
    itemtype
    manualdiscount
    manualcess
    itemmaster_timestamp
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemmaster {
      itemid
      itemcode
      companyid
      enteredtimestamp
      expiredtimestamp
      itemname
      salesinvoiceflag
      purchaseinvoiceflag
      itemcategorycd
      measurementcd
      currencycd
      salesaccountid
      purchaseaccountid
      taxabilitycd
      reversechargeflag
      itemtype
      hsnid
      is_active
      statuscode
      statusmessage
      relateditemamountdetails {
        id
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        amount
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstcompensationvalue
        gstrate
        statuscode
        statusmessage
        lastupdatedby
        discounttype
        discountvalue
        invoicetype
        pricetype
        isactive
        isdefault
        pricetypeid
        tabletype
        __typename
      }
      relateditemgstdetails {
        itemid
        companyid
        enteredtimestamp
        expiredtimestamp
        hsnid
        gstcesstype
        gstcompensationvalue
        effectivedate
        expireddate
        gstcessvalue
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemimages {
        attachmentid
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        imagename
        imageurl
        documentname
        type
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      serialnumber
      financialyearid
      description
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      cessexist
      barcode
      __typename
    }
    pricetypeid
    manualgst
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceLineItemsMutationVariables,
  APITypes.CreateInvoiceLineItemsMutation
>;
export const createInvoiceLineNonGST = /* GraphQL */ `mutation CreateInvoiceLineNonGST(
  $createInvoiceLineNonGSTInput: [CreateInvoiceLineNonGSTInput]
) {
  createInvoiceLineNonGST(
    createInvoiceLineNonGSTInput: $createInvoiceLineNonGSTInput
  ) {
    invoiceid
    invoiceitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    gstrate
    gsttypecd
    gstamount
    cessamount
    cessrate
    cesstype
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceLineNonGSTMutationVariables,
  APITypes.CreateInvoiceLineNonGSTMutation
>;
export const createInvoiceLineNonItems = /* GraphQL */ `mutation CreateInvoiceLineNonItems(
  $createInvoiceLineNonItemsInput: [CreateInvoiceLineNonItemsInput]
) {
  createInvoiceLineNonItems(
    createInvoiceLineNonItemsInput: $createInvoiceLineNonItemsInput
  ) {
    invoiceid
    invoiceitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicelineitemtype
    incomeaccountid
    hsnsaccode
    taxability
    itemdescription
    taxableamount
    netamount
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    gstrate
    gsttypecd
    gstamount
    cessamount
    incomeaccountname
    manualgst
    manualcess
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceLineNonItemsMutationVariables,
  APITypes.CreateInvoiceLineNonItemsMutation
>;
export const createCompanyCodeTranslationArray = /* GraphQL */ `mutation CreateCompanyCodeTranslationArray(
  $createCompanyCodeTranslationArrayInput: [CreateCompanyCodeTranslationArrayInput!]!
) {
  createCompanyCodeTranslationArray(
    createCompanyCodeTranslationArrayInput: $createCompanyCodeTranslationArrayInput
  ) {
    id
    companyid
    codetype
    codevalue
    language
    enteredtimestamp
    expiredtimestamp
    codetext
    codeorder
    statuscode
    statusmessage
    lastupdatedby
    uqc
    is_active
    section
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCompanyCodeTranslationArrayMutationVariables,
  APITypes.CreateCompanyCodeTranslationArrayMutation
>;
export const createInvoiceTCSDetails = /* GraphQL */ `mutation CreateInvoiceTCSDetails(
  $createInvoiceTCSDetailsInput: [CreateInvoiceTCSDetailsInput]
) {
  createInvoiceTCSDetails(
    createInvoiceTCSDetailsInput: $createInvoiceTCSDetailsInput
  ) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tcsapplicablecd
    totaltaxableamount
    ineligibletcflag
    reversechargeflag
    gstcesstotal
    tcsamount
    adjustmentamount
    tcssection
    lastupdatedby
    statuscode
    statusmessage
    tcspercentage
    tcsmanual
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceTCSDetailsMutationVariables,
  APITypes.CreateInvoiceTCSDetailsMutation
>;
export const createPurchaseLineGST = /* GraphQL */ `mutation CreatePurchaseLineGST(
  $createPurchaseLineGSTInput: [CreatePurchaseLineGSTInput]
) {
  createPurchaseLineGST(
    createPurchaseLineGSTInput: $createPurchaseLineGSTInput
  ) {
    purchaseid
    purchaseitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    gstrate
    cessamount
    gstamount
    cessrate
    cesstype
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseLineGSTMutationVariables,
  APITypes.CreatePurchaseLineGSTMutation
>;
export const createPurchaseAttachment = /* GraphQL */ `mutation CreatePurchaseAttachment(
  $createPurchaseAttachmentInput: [CreatePurchaseAttachmentInput]
) {
  createPurchaseAttachment(
    createPurchaseAttachmentInput: $createPurchaseAttachmentInput
  ) {
    purchaseid
    attachmentid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    attachmentname
    attachmenturl
    lastupdatedby
    statuscode
    statusmessage
    documentname
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseAttachmentMutationVariables,
  APITypes.CreatePurchaseAttachmentMutation
>;
export const createPurchaseLineItems = /* GraphQL */ `mutation CreatePurchaseLineItems(
  $createPurchaseLineItemsInput: [CreatePurchaseLineItemsInput]
) {
  createPurchaseLineItems(
    createPurchaseLineItemsInput: $createPurchaseLineItemsInput
  ) {
    purchaseid
    purchaseitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    itemnumber
    itemid
    purchaseaccountid
    hsncode
    itemquantity
    unittypecd
    itemrate
    itemamount
    itemdiscount
    discounttype
    discountrate
    netamount
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemmaster {
      itemid
      itemcode
      companyid
      enteredtimestamp
      expiredtimestamp
      itemname
      salesinvoiceflag
      purchaseinvoiceflag
      itemcategorycd
      measurementcd
      currencycd
      salesaccountid
      purchaseaccountid
      taxabilitycd
      reversechargeflag
      itemtype
      hsnid
      is_active
      statuscode
      statusmessage
      relateditemamountdetails {
        id
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        amount
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstcompensationvalue
        gstrate
        statuscode
        statusmessage
        lastupdatedby
        discounttype
        discountvalue
        invoicetype
        pricetype
        isactive
        isdefault
        pricetypeid
        tabletype
        __typename
      }
      relateditemgstdetails {
        itemid
        companyid
        enteredtimestamp
        expiredtimestamp
        hsnid
        gstcesstype
        gstcompensationvalue
        effectivedate
        expireddate
        gstcessvalue
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemimages {
        attachmentid
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        imagename
        imageurl
        documentname
        type
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      serialnumber
      financialyearid
      description
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      cessexist
      barcode
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    taxability
    pricetype
    lotid
    hsnid
    hsncodetype
    hsndescription
    gstrate
    gstamount
    cessamount
    unit
    uqc
    purchaseaccountname
    itemname
    itemcode
    itemtype
    manualdiscount
    manualcess
    pricetypeid
    manualgst
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseLineItemsMutationVariables,
  APITypes.CreatePurchaseLineItemsMutation
>;
export const createPurchaseLineNonGST = /* GraphQL */ `mutation CreatePurchaseLineNonGST(
  $createPurchaseLineNonGSTInput: [CreatePurchaseLineNonGSTInput]
) {
  createPurchaseLineNonGST(
    createPurchaseLineNonGSTInput: $createPurchaseLineNonGSTInput
  ) {
    purchaseid
    purchaseitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    gstrate
    cessamount
    gstamount
    cessrate
    cesstype
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseLineNonGSTMutationVariables,
  APITypes.CreatePurchaseLineNonGSTMutation
>;
export const createPurchaseLineNonItems = /* GraphQL */ `mutation CreatePurchaseLineNonItems(
  $createPurchaseLineNonItemsInput: [CreatePurchaseLineNonItemsInput]
) {
  createPurchaseLineNonItems(
    createPurchaseLineNonItemsInput: $createPurchaseLineNonItemsInput
  ) {
    purchaseid
    purchaseitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchaselineitemtype
    purchaseaccountid
    hsnsaccode
    itemdescription
    taxableamount
    netamount
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    taxability
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    gstrate
    gstamount
    cessamount
    purchaseaccountname
    manualgst
    manualcess
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseLineNonItemsMutationVariables,
  APITypes.CreatePurchaseLineNonItemsMutation
>;
export const createPurchaseTCSDetails = /* GraphQL */ `mutation CreatePurchaseTCSDetails(
  $createPurchaseTCSDetailsInput: [CreatePurchaseTCSDetailsInput]
) {
  createPurchaseTCSDetails(
    createPurchaseTCSDetailsInput: $createPurchaseTCSDetailsInput
  ) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tcsapplicablecd
    totaltaxableamount
    ineligibletcflag
    reversechargeflag
    gstcesstotal
    tcsamount
    adjustmentamount
    tcssection
    lastupdatedby
    statuscode
    statusmessage
    tcspercentage
    tcsmanual
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseTCSDetailsMutationVariables,
  APITypes.CreatePurchaseTCSDetailsMutation
>;
export const createPurchaseTDSDetails = /* GraphQL */ `mutation CreatePurchaseTDSDetails(
  $createPurchaseTDSDetailsInput: [CreatePurchaseTDSDetailsInput]
) {
  createPurchaseTDSDetails(
    createPurchaseTDSDetailsInput: $createPurchaseTDSDetailsInput
  ) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tdsapplicablecd
    totaltaxableamount
    ineligibletcflag
    reversechargeflag
    gstcesstotal
    tdsamount
    adjustmentamount
    tdssection
    tdspercentage
    tdsmanual
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseTDSDetailsMutationVariables,
  APITypes.CreatePurchaseTDSDetailsMutation
>;
export const createPurchaseMaster = /* GraphQL */ `mutation CreatePurchaseMaster(
  $createPurchaseMasterInput: CreatePurchaseMasterInput!
) {
  createPurchaseMaster(createPurchaseMasterInput: $createPurchaseMasterInput) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              pricetypeid
              manualgst
              cessrate
              cesstype
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseMasterMutationVariables,
  APITypes.CreatePurchaseMasterMutation
>;
export const createCrDrAttachment = /* GraphQL */ `mutation CreateCrDrAttachment(
  $createCrDrAttachmentInput: [CreateCrDrAttachmentInput]
) {
  createCrDrAttachment(createCrDrAttachmentInput: $createCrDrAttachmentInput) {
    crdrnoteid
    attachmentid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    attachmentname
    attachmenturl
    userid
    statuscode
    statusmessage
    documentname
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrAttachmentMutationVariables,
  APITypes.CreateCrDrAttachmentMutation
>;
export const createCrDrNoteDetails = /* GraphQL */ `mutation CreateCrDrNoteDetails(
  $createCrDrNoteDetailsInput: [CreateCrDrNoteDetailsInput]
) {
  createCrDrNoteDetails(
    createCrDrNoteDetailsInput: $createCrDrNoteDetailsInput
  ) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    totaltaxableamount
    totalgst
    totalgstcess
    totaladjustments
    comments
    accountid
    partamount
    transportationcd
    vehiclenumber
    dispatchdate
    ewaybillnumber
    userid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteDetailsMutationVariables,
  APITypes.CreateCrDrNoteDetailsMutation
>;
export const createCrDrNoteDispatch = /* GraphQL */ `mutation CreateCrDrNoteDispatch(
  $createCrDrNoteDispatchInput: [CreateCrDrNoteDispatchInput]
) {
  createCrDrNoteDispatch(
    createCrDrNoteDispatchInput: $createCrDrNoteDispatchInput
  ) {
    crdrnoteid
    dispatchid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transportationcd
    vehiclenumber
    dispatchdate
    ewaybillnumber
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteDispatchMutationVariables,
  APITypes.CreateCrDrNoteDispatchMutation
>;
export const createCrDrNoteInvoices = /* GraphQL */ `mutation CreateCrDrNoteInvoices(
  $createCrDrNoteInvoicesInput: [CreateCrDrNoteInvoicesInput]
) {
  createCrDrNoteInvoices(
    createCrDrNoteInvoicesInput: $createCrDrNoteInvoicesInput
  ) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoiceid
    statuscode
    statusmessage
    lastupdatedby
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteInvoicesMutationVariables,
  APITypes.CreateCrDrNoteInvoicesMutation
>;
export const createCrDrNoteLineItems = /* GraphQL */ `mutation CreateCrDrNoteLineItems(
  $createCrDrNoteLineItemsInput: [CreateCrDrNoteLineItemsInput]
) {
  createCrDrNoteLineItems(
    createCrDrNoteLineItemsInput: $createCrDrNoteLineItemsInput
  ) {
    crdrnoteid
    crdrnoteitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    lineitemnumber
    lineitemtype
    itemid
    quantity
    unittypecd
    itemrate
    itemamount
    itemdiscount
    discounttype
    discountrate
    gstrate
    gsttypecd
    gstamount
    gstcess
    hsnsaccode
    netamount
    userid
    taxability
    reason
    statuscode
    statusmessage
    pricetype
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    unit
    uqc
    salesaccountname
    purchaseaccountname
    salesaccountid
    purchaseaccountid
    itemname
    itemcode
    itemtype
    manualdiscount
    manualcess
    pricetypeid
    manualgst
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteLineItemsMutationVariables,
  APITypes.CreateCrDrNoteLineItemsMutation
>;
export const createCrDrNoteLineNonItems = /* GraphQL */ `mutation CreateCrDrNoteLineNonItems(
  $createCrDrNoteLineNonItemsInput: [CreateCrDrNoteLineNonItemsInput]
) {
  createCrDrNoteLineNonItems(
    createCrDrNoteLineNonItemsInput: $createCrDrNoteLineNonItemsInput
  ) {
    crdrnoteid
    crdrnoteitemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    lineitemtype
    ledgeraccountid
    hsnsaccode
    itemdescription
    taxableamount
    gstrate
    gsttypecd
    gstamount
    gstcess
    netamount
    userid
    taxability
    reason
    statuscode
    statusmessage
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    ledgeraccountname
    manualgst
    manualcess
    cessrate
    cesstype
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteLineNonItemsMutationVariables,
  APITypes.CreateCrDrNoteLineNonItemsMutation
>;
export const createCrDrNoteTCSDetails = /* GraphQL */ `mutation CreateCrDrNoteTCSDetails(
  $createCrDrNoteTCSDetailsInput: [CreateCrDrNoteTCSDetailsInput]
) {
  createCrDrNoteTCSDetails(
    createCrDrNoteTCSDetailsInput: $createCrDrNoteTCSDetailsInput
  ) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tcsapplicablecd
    totaltaxableamount
    ineligibletcflag
    reversechargeflag
    gstcesstotal
    tcsamount
    adjustmentamount
    tcssection
    tcsmanual
    lastupdatedby
    statuscode
    statusmessage
    tcspercentage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteTCSDetailsMutationVariables,
  APITypes.CreateCrDrNoteTCSDetailsMutation
>;
export const createCrDrNoteTDSDetails = /* GraphQL */ `mutation CreateCrDrNoteTDSDetails(
  $createCrDrNoteTDSDetailsInput: [CreateCrDrNoteTDSDetailsInput]
) {
  createCrDrNoteTDSDetails(
    createCrDrNoteTDSDetailsInput: $createCrDrNoteTDSDetailsInput
  ) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tdsapplicablecd
    totaltaxableamount
    ineligibletcflag
    reversechargeflag
    gstcesstotal
    tdsamount
    adjustmentamount
    tdssection
    tdspercentage
    tcsmanual
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteTDSDetailsMutationVariables,
  APITypes.CreateCrDrNoteTDSDetailsMutation
>;
export const createCrDrNoteMaster = /* GraphQL */ `mutation CreateCrDrNoteMaster(
  $createCrDrNoteMasterInput: CreateCrDrNoteMasterInput!
) {
  createCrDrNoteMaster(createCrDrNoteMasterInput: $createCrDrNoteMasterInput) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    crdrnotetypecd
    crdrnotedate
    crdrnotenumber
    invoicetypecd
    gsttypecd
    partyid
    deliveryaddressid
    paymenttype
    grandtotalamount
    transactionid
    userid
    creditduration
    statuscode
    statusmessage
    psflag
    reversechargeflag
    balancedueamount
    consigneename
    consigneegstin
    companystate
    placeofsupply
    cancelflag
    cancelremark
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    relatedcrdrnoteinvoices {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoiceid
      statuscode
      statusmessage
      lastupdatedby
      __typename
    }
    relatedcrdrattachment {
      crdrnoteid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      userid
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedcrdrnotedetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      totaltaxableamount
      totalgst
      totalgstcess
      totaladjustments
      comments
      accountid
      partamount
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      userid
      statuscode
      statusmessage
      __typename
    }
    relatedcrdrnotelineitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      lineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      discounttype
      discountrate
      gstrate
      gsttypecd
      gstamount
      gstcess
      hsnsaccode
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      pricetype
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      unit
      uqc
      salesaccountname
      purchaseaccountname
      salesaccountid
      purchaseaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      __typename
    }
    relatedcrdrnotelinenonitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemtype
      ledgeraccountid
      hsnsaccode
      itemdescription
      taxableamount
      gstrate
      gsttypecd
      gstamount
      gstcess
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      ledgeraccountname
      manualgst
      manualcess
      cessrate
      cesstype
      __typename
    }
    relatedcrdrnotetcsdetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      tcsmanual
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      __typename
    }
    relatedcrdrnotetdsdetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tcsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedcrdrnotedispatch {
      crdrnoteid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    serialnumber
    currencycode
    currencyrate
    partamount
    originalinvoicenumber
    partyinvoicenumber
    totalgst
    totalgstcess
    totaltaxableamount
    totaladjustments
    comments
    accountid
    transportationcd
    vehiclenumber
    dispatchdate
    ewaybillnumber
    paymentstatus
    crdrnotepdf
    partydisplayname
    partylegalname
    partyaccountid
    partygstcategory
    partyemail
    partytypecd
    partygstin
    accountname
    partyregistrationtype
    duedatetimestamp
    overduedays
    partyisactive
    isvouchereditable
    itcflag
    cessexist
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCrDrNoteMasterMutationVariables,
  APITypes.CreateCrDrNoteMasterMutation
>;
export const updateAccountMaster = /* GraphQL */ `mutation UpdateAccountMaster(
  $updateAccountMasterInput: UpdateAccountMasterInput!
) {
  updateAccountMaster(updateAccountMasterInput: $updateAccountMasterInput) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountMasterMutationVariables,
  APITypes.UpdateAccountMasterMutation
>;
export const updateAccountGroupMaster = /* GraphQL */ `mutation UpdateAccountGroupMaster(
  $updateAccountGroupMasterInput: UpdateAccountGroupMasterInput!
) {
  updateAccountGroupMaster(
    updateAccountGroupMasterInput: $updateAccountGroupMasterInput
  ) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountGroupMasterMutationVariables,
  APITypes.UpdateAccountGroupMasterMutation
>;
export const deleteAccountMaster = /* GraphQL */ `mutation DeleteAccountMaster($accountsid: Int!) {
  deleteAccountMaster(accountsid: $accountsid) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountMasterMutationVariables,
  APITypes.DeleteAccountMasterMutation
>;
export const deleteAccountGroupMaster = /* GraphQL */ `mutation DeleteAccountGroupMaster($accountgroupid: Int!) {
  deleteAccountGroupMaster(accountgroupid: $accountgroupid) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountGroupMasterMutationVariables,
  APITypes.DeleteAccountGroupMasterMutation
>;
export const deleteNumberTracker = /* GraphQL */ `mutation DeleteNumberTracker(
  $deleteNumberTrackerInput: DeleteNumberTrackerInput
) {
  deleteNumberTracker(deleteNumberTrackerInput: $deleteNumberTrackerInput) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNumberTrackerMutationVariables,
  APITypes.DeleteNumberTrackerMutation
>;
export const updateNumberTracker = /* GraphQL */ `mutation UpdateNumberTracker(
  $updateNumberTrackerInput: UpdateNumberTrackerInput!
) {
  updateNumberTracker(updateNumberTrackerInput: $updateNumberTrackerInput) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNumberTrackerMutationVariables,
  APITypes.UpdateNumberTrackerMutation
>;
export const updateAccountGSTDetails = /* GraphQL */ `mutation UpdateAccountGSTDetails(
  $updateAccountGSTDetailsInput: UpdateAccountGSTDetailsInput!
) {
  updateAccountGSTDetails(
    updateAccountGSTDetailsInput: $updateAccountGSTDetailsInput
  ) {
    accountid
    companyid
    enteredtimestamp
    expiredtimestamp
    effectivedate
    expireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    lastupdatedby
    statuscode
    statusmessage
    hsnsaccode
    codetype
    description
    taxability
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountGSTDetailsMutationVariables,
  APITypes.UpdateAccountGSTDetailsMutation
>;
export const deleteTransactionMaster = /* GraphQL */ `mutation DeleteTransactionMaster($transactionid: Int!) {
  deleteTransactionMaster(transactionid: $transactionid) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionMasterMutationVariables,
  APITypes.DeleteTransactionMasterMutation
>;
export const deleteNumberTrackerByType = /* GraphQL */ `mutation DeleteNumberTrackerByType(
  $deleteNumberTrackerByTypeInput: DeleteNumberTrackerByTypeInput
) {
  deleteNumberTrackerByType(
    deleteNumberTrackerByTypeInput: $deleteNumberTrackerByTypeInput
  ) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNumberTrackerByTypeMutationVariables,
  APITypes.DeleteNumberTrackerByTypeMutation
>;
export const deleteNumberTrackerAuto = /* GraphQL */ `mutation DeleteNumberTrackerAuto(
  $deleteNumberTrackerAutoByTypeInput: DeleteNumberTrackerAutoByTypeInput
) {
  deleteNumberTrackerAuto(
    deleteNumberTrackerAutoByTypeInput: $deleteNumberTrackerAutoByTypeInput
  ) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNumberTrackerAutoMutationVariables,
  APITypes.DeleteNumberTrackerAutoMutation
>;
export const closeFinancialYear = /* GraphQL */ `mutation CloseFinancialYear(
  $currentfinancialyearid: Int!
  $nextfinancialyearid: Int!
  $excludedaccountidlist: String!
) {
  closeFinancialYear(
    currentfinancialyearid: $currentfinancialyearid
    nextfinancialyearid: $nextfinancialyearid
    excludedaccountidlist: $excludedaccountidlist
  ) {
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CloseFinancialYearMutationVariables,
  APITypes.CloseFinancialYearMutation
>;
export const transferAccountsToFinancialYear = /* GraphQL */ `mutation TransferAccountsToFinancialYear(
  $excludedaccountidlist: String!
  $excludedaccountgroupidlist: String!
  $ledger_transfer_option: Int!
  $party_transfer_option: Int!
  $item_transfer_option: Int!
  $transfer_groups_ledgers: Int!
  $ledger_closing_balance: Int!
  $party_closing_balance: Int!
  $from_financialyearid: Int!
  $to_financialyearid: Int!
) {
  transferAccountsToFinancialYear(
    excludedaccountidlist: $excludedaccountidlist
    excludedaccountgroupidlist: $excludedaccountgroupidlist
    ledger_transfer_option: $ledger_transfer_option
    party_transfer_option: $party_transfer_option
    item_transfer_option: $item_transfer_option
    transfer_groups_ledgers: $transfer_groups_ledgers
    ledger_closing_balance: $ledger_closing_balance
    party_closing_balance: $party_closing_balance
    from_financialyearid: $from_financialyearid
    to_financialyearid: $to_financialyearid
  ) {
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TransferAccountsToFinancialYearMutationVariables,
  APITypes.TransferAccountsToFinancialYearMutation
>;
export const createtransferfinancialyeardata = /* GraphQL */ `mutation Createtransferfinancialyeardata(
  $companybranchid: Int!
  $startdate: Int!
  $enddate: Int!
  $startyear: String!
  $endyear: String!
  $comments: String!
  $aliasname: String!
  $excludedaccountidlist: String!
  $excludedaccountgroupidlist: String!
  $ledger_transfer_option: Int!
  $party_transfer_option: Int!
  $item_transfer_option: Int!
  $transfer_groups_ledgers: Int!
  $ledger_closing_balance: Int!
  $party_closing_balance: Int!
  $from_financialyearid: Int!
  $to_financialyearid: Int!
) {
  createtransferfinancialyeardata(
    companybranchid: $companybranchid
    startdate: $startdate
    enddate: $enddate
    startyear: $startyear
    endyear: $endyear
    comments: $comments
    aliasname: $aliasname
    excludedaccountidlist: $excludedaccountidlist
    excludedaccountgroupidlist: $excludedaccountgroupidlist
    ledger_transfer_option: $ledger_transfer_option
    party_transfer_option: $party_transfer_option
    item_transfer_option: $item_transfer_option
    transfer_groups_ledgers: $transfer_groups_ledgers
    ledger_closing_balance: $ledger_closing_balance
    party_closing_balance: $party_closing_balance
    from_financialyearid: $from_financialyearid
    to_financialyearid: $to_financialyearid
  ) {
    statuscode
    statusmessage
    financialyearid
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatetransferfinancialyeardataMutationVariables,
  APITypes.CreatetransferfinancialyeardataMutation
>;
export const deleteFinancialYear = /* GraphQL */ `mutation DeleteFinancialYear($financialyearid: Int!) {
  deleteFinancialYear(financialyearid: $financialyearid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFinancialYearMutationVariables,
  APITypes.DeleteFinancialYearMutation
>;
export const freezeFinancialYear = /* GraphQL */ `mutation FreezeFinancialYear($financialyearid: Int!) {
  freezeFinancialYear(financialyearid: $financialyearid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FreezeFinancialYearMutationVariables,
  APITypes.FreezeFinancialYearMutation
>;
export const unFreezeFinancialYear = /* GraphQL */ `mutation UnFreezeFinancialYear($financialyearid: Int!) {
  unFreezeFinancialYear(financialyearid: $financialyearid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UnFreezeFinancialYearMutationVariables,
  APITypes.UnFreezeFinancialYearMutation
>;
export const deletecancelinvoices = /* GraphQL */ `mutation Deletecancelinvoices(
  $invoicetype: String!
  $invoiceid: Int!
  $mode: String!
  $paymentincluded: Int!
  $reason: String!
) {
  deletecancelinvoices(
    invoicetype: $invoicetype
    invoiceid: $invoiceid
    mode: $mode
    paymentincluded: $paymentincluded
    reason: $reason
  ) {
    newid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletecancelinvoicesMutationVariables,
  APITypes.DeletecancelinvoicesMutation
>;
export const createuserissue = /* GraphQL */ `mutation Createuserissue($userIssueInput: UserIssueInput) {
  createuserissue(userIssueInput: $userIssueInput) {
    StatusMessage
    StatusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateuserissueMutationVariables,
  APITypes.CreateuserissueMutation
>;
export const createtransporter = /* GraphQL */ `mutation Createtransporter($transporterMasterInput: TransporterMasterInput!) {
  createtransporter(transporterMasterInput: $transporterMasterInput) {
    transporterid
    transportername
    companyid
    enteredtimestamp
    lastupdatedby
    expiredtimestamp
    transportergstin
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatetransporterMutationVariables,
  APITypes.CreatetransporterMutation
>;
export const createEwayBill = /* GraphQL */ `mutation CreateEwayBill($createEwayBillInput: CreateEwayBillInput!) {
  createEwayBill(createEwayBillInput: $createEwayBillInput) {
    id
    invoiceid
    invoicetype
    companyid
    enteredtimestamp
    expiredtimestamp
    ewaybillno
    expirydate
    is_cancelled
    cancel_remarks
    lastupdatedby
    cancel_rsn_code
    ewaybilldate
    supplytype
    subtype
    partyid
    transporterid
    modeoftransport
    vehicleno
    distance
    invoiceno
    invoicedate
    fromgstin
    togstin
    fromstate
    tostate
    frompincode
    topincode
    billingstate
    billingpincode
    transportername
    transportergstin
    validupto
    total_items_count
    gstrate
    gstamount
    cessamount
    ewbrejecteddate
    totalitemamount
    totalinvoiceamount
    fromtradename
    totradename
    transactiontype
    doctype
    status
    transdocno
    transdocdate
    vehicletype
    ewaybillpdf
    addresses {
      objectid
      objecttype
      statecode
      statename
      pincode
      line1
      line2
      line3
      city
      countrycode
      district
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEwayBillMutationVariables,
  APITypes.CreateEwayBillMutation
>;
export const createAppVersion = /* GraphQL */ `mutation CreateAppVersion(
  $version_number: String!
  $release_notes: String
  $is_mandatory: Boolean!
) {
  createAppVersion(
    version_number: $version_number
    release_notes: $release_notes
    is_mandatory: $is_mandatory
  ) {
    id
    version_number
    release_notes
    release_date
    is_mandatory
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppVersionMutationVariables,
  APITypes.CreateAppVersionMutation
>;
export const createTransactionAttachment = /* GraphQL */ `mutation CreateTransactionAttachment(
  $createTransactionAttachmentInput: [CreateTransactionAttachmentInput!]!
) {
  createTransactionAttachment(
    createTransactionAttachmentInput: $createTransactionAttachmentInput
  ) {
    transactionid
    attachmentid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    attachmentname
    attachmenturl
    lastupdatedby
    documentname
    statuscode
    statusmessage
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionAttachmentMutationVariables,
  APITypes.CreateTransactionAttachmentMutation
>;
export const createItemOpeningStock = /* GraphQL */ `mutation CreateItemOpeningStock(
  $createItemOpeningStockInput: CreateItemOpeningStockInput!
) {
  createItemOpeningStock(
    createItemOpeningStockInput: $createItemOpeningStockInput
  ) {
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemOpeningStockMutationVariables,
  APITypes.CreateItemOpeningStockMutation
>;
export const createUserInvitation = /* GraphQL */ `mutation CreateUserInvitation(
  $createUserInvitationInput: CreateUserInvitationInput!
) {
  createUserInvitation(createUserInvitationInput: $createUserInvitationInput) {
    id
    email
    companyid
    invitedby
    status
    invitationtoken
    invitationsource
    acceptedtimestamp
    enteredtimestamp
    expiredtimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserInvitationMutationVariables,
  APITypes.CreateUserInvitationMutation
>;
export const createTransactionWithSpecificTimev2 = /* GraphQL */ `mutation CreateTransactionWithSpecificTimev2(
  $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
) {
  createTransactionWithSpecificTimev2(
    createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
  ) {
    transactionid
    companyid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionWithSpecificTimev2MutationVariables,
  APITypes.CreateTransactionWithSpecificTimev2Mutation
>;
export const updatefinancialyearsteps = /* GraphQL */ `mutation Updatefinancialyearsteps(
  $updatefinancialyearstepsInput: [UpdatefinancialyearstepsInput!]!
) {
  updatefinancialyearsteps(
    updatefinancialyearstepsInput: $updatefinancialyearstepsInput
  ) {
    financialyearid
    stepscompleted
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatefinancialyearstepsMutationVariables,
  APITypes.UpdatefinancialyearstepsMutation
>;
